import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getDocumentCategories = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}get_document_categories`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getDocumentCategories